/**
 * It removes element when declared country doesnt' match current locale. It can't be bounded to <template>
 * Binding value examples:
 *  - 'it',
 *  - ['it'],
 *  - ['it', 'es']
 *
 * @example
 * <div v-remove-on-country="['it', 'es']">Removed in Italy and Spain!</div>
 */
export default {
    inserted(el, binding, vnode) {
        const list = Array.isArray(binding.value) ? binding.value : [String(binding.value)];
        // @TODO Check if we can inject $i18n without referring to vnode context.
        const i18n = vnode.context.$i18n || {};
        const index = list.findIndex((item) => item === i18n.locale);
        if (index !== -1) {
            try {
                el.remove();
            } catch (e) {
                // IE11
                el.parentNode.removeChild(el);
            }
        }
    },
};
